import { ServerListRequest, ServerListResponse } from '@lumapps/base-api';
import { Group } from '@lumapps/groups/types';
import { SpaceUserRole } from '@lumapps/spaces/types';
import { User } from '@lumapps/user/types';

export enum ConfigurationDialogSteps {
    information = 'information',
    visibility = 'visibility',
    members = 'members',
    services = 'services',
    spaceServices = 'spaceServices',
    posts = 'posts',
    options = 'options',
}

/** Types related to Members Step */

export enum CommunityMemberType {
    REQUESTS = 'requests',
    USERS = 'users',
    GROUPS = 'groups',
    GROUPS_FOLLOWING = 'groupsFollowing',
}

export enum CommmunityMemberRole {
    MANAGER = 'manager',
    MEMBER = 'member',
}
export interface CommunityUserMember extends Partial<User> {
    customer?: string;
    id: string;
    fullName: string;
    jobTitle?: string;
    role: CommmunityMemberRole;
    profilePictureUrl?: string;
    isBeingDeleted?: boolean;
}

export type PickedUsersApiResponse = ServerListResponse<{
    id: string;
    fullName?: string;
    profilePrimaryFieldValues?: string[];
    profilePictureUrl?: string;
    role: SpaceUserRole;
}>;

export interface PickedUsersApiOptions extends Partial<Pick<ServerListRequest, 'maxResults' | 'cursor' | 'query'>> {
    role?: SpaceUserRole;
}

export interface CommunityGroupMember extends Group {
    role: CommmunityMemberRole;
}

export type CommunityMember = CommunityUserMember | CommunityGroupMember;

export enum FetchMembersStatus {
    initial = 'initial',
    loading = 'loading',
    loadingMore = 'loadingMore',
    loaded = 'loaded',
    error = 'error',
}
